import api from "./api";

const tubeTypeService = {
  getAllTubeTypes: (activeOnly = true) =>
    api.get("/tube-types", { params: { active: activeOnly } }),

  getTubeTypeById: (id) => api.get(`/tube-types/${id}`),

  createTubeType: (tubeTypeData) => api.post("/tube-types", tubeTypeData),

  updateTubeType: (id, tubeTypeData) => api.put(`/tube-types/${id}`, tubeTypeData),

  deleteTubeType: (id) => api.delete(`/tube-types/${id}`),
};

export default tubeTypeService;
